// ============================================================================
// AVATAR-TRIGGERABLE SESSION TASKS
//
// Mirrors backend/src/config/avatar-triggerable-tasks.ts. Kept in sync by
// hand — this codebase has no shared package between frontend and backend.
// Display-only here (name/description for the confirm modal); the backend
// copy is the one that actually gates what draft.templateId is legal.
// ============================================================================

export interface AvatarTriggerableTask {
  templateId: string;
  name: string;
  description: string;
  taskCategory: 'thinking' | 'doing';
  instructionField: string;
}

export const AVATAR_TRIGGERABLE_TASKS: AvatarTriggerableTask[] = [
  {
    templateId: 'session-task-html-artifact',
    name: 'Generate HTML Artifact',
    description: 'Generate a custom HTML page from a plain-English instruction — process flows, dashboards, data visualisations, presentations.',
    taskCategory: 'doing',
    instructionField: 'text',
  },
];

export function getAvatarTriggerableTask(templateId: string): AvatarTriggerableTask | undefined {
  return AVATAR_TRIGGERABLE_TASKS.find(t => t.templateId === templateId);
}
